"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const megamenu_1 = require("@/Redux/Actions/megamenu");
const useOnOutsideClick_1 = require("@/Hooks/useOnOutsideClick");
const style = __importStar(require("./styled"));
const MenuItemFirst_1 = __importDefault(require("./MenuItems/MenuItemFirst"));
const useDisableScroll_1 = __importDefault(require("@/Hooks/useDisableScroll"));
const spa_core_1 = require("@episerver/spa-core");
const Theme_1 = require("@/Theme");
const react_router_dom_1 = require("react-router-dom");
const Typography_1 = require("@/Components/UI/Typography");
const svg_components_1 = require("@/assets/svg-components");
const RegionMenu_1 = __importDefault(require("../RegionMenu/RegionMenu"));
const Search_1 = __importDefault(require("../Search/Search"));
const cart_1 = require("@/Redux/Actions/cart");
const user_1 = require("@/Endpoints/user");
const user_2 = require("@/Redux/Actions/user");
const Types_1 = require("Types");
const useUserData_1 = __importDefault(require("@/Hooks/useUserData"));
const Hooks_1 = require("@/Hooks");
const ExpressBanner_1 = __importDefault(require("@/Components/Partials/ExpressBanner"));
const Constants_1 = require("@/Constants");
const useInitialData_1 = __importDefault(require("@/Hooks/useInitialData"));
const loginModal_1 = require("@/Redux/Actions/loginModal");
const request_1 = require("@/Endpoints/request");
const createThrottle_1 = __importDefault(require("@/Hooks/createThrottle"));
const Utils_1 = require("@/Utils");
const MessageBanner_1 = __importDefault(require("app/Components/MessageBanner"));
const THROTTLE_DELAY = 200;
const MobileMenu = ({ headerData, activeRegion, isRegional, showMiniCartIcon }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const isMegaMenuOpen = (0, react_redux_1.useSelector)((state) => state.menuToggle.isOpen);
    const miniCartData = (0, react_redux_1.useSelector)((state) => state.cart.cartData);
    const dispatch = (0, react_redux_1.useDispatch)();
    const toggleScroll = (0, useDisableScroll_1.default)();
    const wrapperRef = (0, react_1.useRef)(null);
    (0, useOnOutsideClick_1.useOnOutsideClick)(wrapperRef, () => dispatch((0, megamenu_1.setIsMegaMenuOpen)(false)));
    const cmsState = (0, spa_core_1.useCmsState)();
    const isForceReloadLink = `${!(cmsState === null || cmsState === void 0 ? void 0 : cmsState.iContent)}`;
    const gotHeroImage = (cmsState && cmsState.iContent && 'heroImageDesktop' in cmsState.iContent) ||
        (cmsState && cmsState.iContent && 'heroImageMobile' in cmsState.iContent);
    const [isTransparent, setIsTransparent] = (0, react_1.useState)(gotHeroImage);
    const [isSearchOpen, setIsSearchOpen] = (0, react_1.useState)(false);
    const [isRegionOpen, setIsRegionOpen] = (0, react_1.useState)(false);
    const { isLoginModalOpen } = (0, react_redux_1.useSelector)((state) => state.loginModal);
    const { isFavoriteShiptosModalOpen } = (0, react_redux_1.useSelector)((state) => state.favoriteShiptosModal);
    const userData = (0, useUserData_1.default)();
    const initialData = (0, useInitialData_1.default)();
    const history = (0, react_router_dom_1.useHistory)();
    const { t } = (0, Hooks_1.useTranslate)();
    const menuIconsColor = isTransparent ? Theme_1.theme.palette.BW_100 : Theme_1.theme.palette.LIGHT_BLACK;
    const isDoubleDigits = miniCartData.numberOfItems > 9;
    const isEurope = Constants_1.EUROPE.includes((_a = initialData === null || initialData === void 0 ? void 0 : initialData.continent) === null || _a === void 0 ? void 0 : _a.toLowerCase());
    const canSeeBanner = isEurope && userData.isAuthenticated && (userData === null || userData === void 0 ? void 0 : userData.roles) && userData.roles.includes(Types_1.UserRoles.EU_PLACE_ORDERS);
    const toggleOpen = (open) => {
        dispatch((0, megamenu_1.setIsMegaMenuOpen)(open));
        toggleScroll(open);
    };
    const openRegionPicker = () => {
        dispatch((0, megamenu_1.setIsMegaMenuOpen)(false));
        toggleScroll(true);
        setIsRegionOpen(true);
    };
    const openLoginModal = (isAuthenticated) => {
        dispatch((0, megamenu_1.setIsMegaMenuOpen)(false));
        toggleScroll(true);
        if (isAuthenticated) {
            const myHaldexUri = initialData.pages.myHaldexPage;
            if (!myHaldexUri) {
                return;
            }
            history.push(myHaldexUri);
            return;
        }
        dispatch((0, loginModal_1.setIsLoginModalOpen)(true));
    };
    const openSearch = () => {
        dispatch((0, megamenu_1.setIsMegaMenuOpen)(false));
        setIsSearchOpen(true);
    };
    const openCart = () => {
        dispatch((0, cart_1.setIsOpen)(true));
    };
    const handleLogout = () => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield (0, user_1.logoutUser)();
        (0, Utils_1.deleteCookie)(Constants_1.Cookies.IS_SHIPTO_ADDED);
        dispatch((0, user_2.fetchUserData)());
        result === request_1.ResponseTypes.OK && dispatch((0, loginModal_1.setIsLoginModalOpen)(false));
    });
    const [isScrolled, setIsScrolled] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const handleScroll = () => {
            if (window.scrollY === 0) {
                setIsTransparent(gotHeroImage);
            }
            else {
                setIsTransparent(false);
            }
            setIsScrolled(window.scrollY !== 0);
        };
        const throttledFunc = (0, createThrottle_1.default)(() => handleScroll(), THROTTLE_DELAY);
        window.addEventListener('scroll', throttledFunc);
        return () => {
            window.removeEventListener('scroll', throttledFunc);
        };
    }, [gotHeroImage]);
    (0, react_1.useEffect)(() => {
        const unsubscribe = history.listen(() => {
            if (isMegaMenuOpen || isRegionOpen) {
                dispatch((0, megamenu_1.setIsMegaMenuOpen)(false));
                setIsRegionOpen(false);
                toggleScroll(false);
            }
        });
        return unsubscribe;
    }, [history, isMegaMenuOpen, isRegionOpen, dispatch, toggleScroll]);
    (0, react_1.useEffect)(() => {
        if (!isRegionOpen && !isMegaMenuOpen && !isLoginModalOpen && !isFavoriteShiptosModalOpen) {
            toggleScroll(false);
        }
    }, [isRegionOpen, isMegaMenuOpen, isLoginModalOpen, isFavoriteShiptosModalOpen]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname) {
            const path = window.location.pathname;
            const modifiedString = path.startsWith('/') ? path.substring(1) : path;
            const homePage = ((_b = modifiedString === null || modifiedString === void 0 ? void 0 : modifiedString.split('/')) === null || _b === void 0 ? void 0 : _b.length) <= 1;
            const langCookie = (0, Utils_1.getCookie)(Constants_1.LANGUAGE_COOKIE);
            const continentCookie = (0, Utils_1.getCookie)(Constants_1.CONTINENT_COOKIE);
            if (homePage && !isRegional && !langCookie && !continentCookie) {
                openRegionPicker();
            }
        }
    }, []);
    const isGlobalMarket = ((_b = initialData === null || initialData === void 0 ? void 0 : initialData.continent) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === Constants_1.GLOBAL_MARKET;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(style.MobileNav, { ref: wrapperRef, isTransparent: isMegaMenuOpen === true ? false : isTransparent, isFixed: gotHeroImage, isOpen: isMegaMenuOpen, isScrolled: isScrolled },
            react_1.default.createElement(MessageBanner_1.default, null),
            react_1.default.createElement(ExpressBanner_1.default, { bannerText: t('/haldex/express_banner/title'), expiredText: t('/haldex/express_banner/expired'), canSeeBanner: canSeeBanner }),
            react_1.default.createElement(style.Header, { isOpen: isMegaMenuOpen },
                ((_c = headerData.settings) === null || _c === void 0 ? void 0 : _c.logo) && (react_1.default.createElement(style.LogoContainer, null,
                    react_1.default.createElement("a", { href: headerData.LogoUrl, "data-force-reload": isForceReloadLink },
                        react_1.default.createElement(style.Image, { src: headerData.settings.logo, alt: "logo" })),
                    ((_f = (_e = (_d = headerData === null || headerData === void 0 ? void 0 : headerData.settings) === null || _d === void 0 ? void 0 : _d.linkedSite) === null || _e === void 0 ? void 0 : _e.link) === null || _f === void 0 ? void 0 : _f.href) && (react_1.default.createElement(style.LinkedSite, { href: headerData.settings.linkedSite.link.href, target: (_g = headerData.settings.linkedSite.link) === null || _g === void 0 ? void 0 : _g.target }, isMegaMenuOpen || !isTransparent ? (react_1.default.createElement("img", { src: (_h = headerData.settings.linkedSite) === null || _h === void 0 ? void 0 : _h.greyLogoUrl, alt: (_j = headerData.settings.linkedSite) === null || _j === void 0 ? void 0 : _j.text })) : (react_1.default.createElement("img", { src: (_k = headerData.settings.linkedSite) === null || _k === void 0 ? void 0 : _k.whiteLogoUrl, alt: (_l = headerData.settings.linkedSite) === null || _l === void 0 ? void 0 : _l.text })))))),
                react_1.default.createElement(style.IconContainer, null,
                    react_1.default.createElement(style.SearchIcon, { stroke: menuIconsColor, onClick: openSearch }),
                    isRegional && showMiniCartIcon && (react_1.default.createElement(react_1.default.Fragment, null, miniCartData.numberOfItems > 0 ? (react_1.default.createElement(style.CartContainer, { onClick: openCart },
                        react_1.default.createElement(style.CartIcon, { stroke: menuIconsColor, "$hasCartItems": true }),
                        react_1.default.createElement(style.CartTextCircle, { isBigCircle: isDoubleDigits },
                            react_1.default.createElement(style.CartText, { type: Typography_1.Types.BODY_3 }, miniCartData.numberOfItems)))) : (react_1.default.createElement(style.CartIcon, { stroke: menuIconsColor, onClick: openCart })))),
                    isMegaMenuOpen ? (react_1.default.createElement(style.BurgerClosed, { onClick: () => toggleOpen(false) })) : (react_1.default.createElement(style.BurgerOpen, { onClick: () => toggleOpen(true), stroke: menuIconsColor })))),
            react_1.default.createElement(style.Menu, { isOpen: isMegaMenuOpen },
                headerData.menuData.length && headerData.menuData.map((item, i) => react_1.default.createElement(MenuItemFirst_1.default, Object.assign({ key: i }, item))),
                react_1.default.createElement(style.OtherContainer, { isOpen: isMegaMenuOpen },
                    !userData.isLoading && !isGlobalMarket && (react_1.default.createElement(style.AccountContainer, null,
                        react_1.default.createElement(style.LoginButton, { variant: Types_1.ButtonVariants.ONLY_TEXT, onClick: () => openLoginModal(userData.isAuthenticated) },
                            react_1.default.createElement(svg_components_1.UserIcon, null),
                            react_1.default.createElement(style.OtherTitle, { type: Typography_1.Types.EYEBROW_SMALL }, t('/haldex/header/my_haldex'))),
                        userData.isAuthenticated && (react_1.default.createElement(style.LogoutButton, { variant: Types_1.ButtonVariants.ONLY_TEXT, onClick: handleLogout },
                            react_1.default.createElement(style.LogoutText, { type: Typography_1.Types.BODY_2 }, t('/haldex/header/logout')))))),
                    react_1.default.createElement(style.RegionContainer, { onClick: openRegionPicker },
                        react_1.default.createElement(svg_components_1.RegionIcon, { stroke: Theme_1.theme.palette.BW_0 }),
                        react_1.default.createElement(style.OtherTitle, { type: Typography_1.Types.EYEBROW_SMALL }, activeRegion))))),
        isRegionOpen && ((_m = headerData.settings) === null || _m === void 0 ? void 0 : _m.regions) && (react_1.default.createElement(RegionMenu_1.default, { setIsRegionOpen: setIsRegionOpen, activeRegion: activeRegion, regions: headerData.settings.regions, linkedSite: (_o = headerData.settings) === null || _o === void 0 ? void 0 : _o.linkedSite })),
        isSearchOpen && react_1.default.createElement(Search_1.default, { setIsSearchOpen: setIsSearchOpen })));
};
exports.default = MobileMenu;
